const resultFunction = (data) => {
  return new Map(
    data
      .filter((item) => item.walletBanner?.dappId)
      .map(({ conditions, walletBanner: { dappId, dappUrl, isSpecialOffer } }) => [
        dappId,
        {
          dappId,
          dappUrl,
          isSpecialOffer,
          isDev: conditions?.includes('dev'),
        },
      ])
  )
}

const dappsFromWalletBanners = {
  id: 'dappsFromWalletBanners',
  resultFunction,
  dependencies: [{ selector: 'allAnnouncements' }],
}

export default dappsFromWalletBanners
